module.exports = __webpack_public_path__ + "static/media/milo2.84ef7817.png";